<!-- src/components/ReconciliationTabs.vue -->
<template>
  <div class="page-card relaciliation">
    <el-tabs v-model="activeTab">
      <el-tab-pane :label="getLabel" name="statement">
        <statement-tab v-if="activeTab === 'statement'"></statement-tab>
      </el-tab-pane>
      <el-tab-pane label="往来单据" name="transaction">
        <transaction-tab v-if="activeTab === 'transaction'"></transaction-tab>
      </el-tab-pane>
      <el-tab-pane label="支付明细" name="payment">
        <payment-detail-tab v-if="activeTab === 'payment'"></payment-detail-tab>
      </el-tab-pane>
      <el-tab-pane label="预付" name="prepay">
        <prepay-tab v-if="activeTab === 'prepay'"></prepay-tab>
      </el-tab-pane>
      <el-tab-pane label="预收" name="preReceive">
        <pre-receive-tab v-if="activeTab === 'preReceive'"></pre-receive-tab>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import StatementTab from "./StatementTab.vue";
import TransactionTab from "./TransactionTab.vue";
import PaymentDetailTab from "./PaymentDetailTab.vue";
import PrepayTab from "./PrepayTab.vue";
import PreReceiveTab from "./PreReceiveTab.vue";
import { statementList } from "@/api/reconciliation";
export default {
  name: "ReconciliationTabs",
  components: {
    StatementTab,
    TransactionTab,
    PaymentDetailTab,
    PrepayTab,
    PreReceiveTab
  },
  computed: {
    getLabel() {
      if (this.toCooperatorPay) {
        return `对账单(${this.toCooperatorPay})`;
      } else {
        return "对账单";
      }
    }
  },
  data() {
    return {
      activeTab: "statement",
      toCooperatorPay: 0
    };
  },
  mounted() {
    statementList({ page: 1, pageSize: 1, statementStatus: 2 }).then(res => {
      this.toCooperatorPay = res.totalSize || 0;
    });
  }
};
</script>
<style>
.relaciliation .search-box > .left {
  flex-wrap: wrap;
  width: calc(100% - 100px);
  row-gap: 12px;
}
</style>
<style scoped>
.page-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
